import { computed, toRefs, ref } from 'vue';
import ReactiveFetch from 'utils/ReactiveFetch';
import bokalSourage from 'services/bokalSourage';
import E from 'services/emitter';

import {
  login, fetchProfile, logout,
  requestChangePassword, changePassword,
} from 'api/identity';

import { PERMS, ROLES } from 'const/access';
import { withResData } from 'utils';
import { Entity } from './store';

const LS_KEY = 'Identity.state';
const _isHakim = bokalSourage.get('Identity.isHakim');
const name = 'Identity';

const Identity = (() => {
  // const lsState = bokalSourage.get(LS_KEY);
  const state = new ReactiveFetch();
  // if (lsState)
  //   state.data = lsState;

  const data = computed(() => state.data);
  const acc = computed(() => state.data?.account);
  const accs = computed(() => state.accs);
  const role = computed(() => state.data?.role);
  const isHakim = computed(() => _isHakim || state.data?.id === '5b3f7e3713025f0007f3628e');

  const source = ref(null);

  const values = {
    // state,
    isFetching: computed(() => state.meta?.pending),
    isAuth: computed(() => !!state.data),
    ready: computed(() => source.value === 'server'),

    data,
    acc,
    accs,
    role,

    can: (perm) => role.value === ROLES.OWNER || !!~perm.indexOf(role.value),

    imgSizeLimit: (adsAccType) =>
      adsAccType ? acc.value?.maxImageSize[adsAccType] : acc.value?.maxImageSize,

    perms: computed(() => {
      const calced = { ...PERMS };
      for (const [sectionName, _acts] of Object.entries(calced)) {
        const acts = { ..._acts };
        calced[sectionName] = acts;

        for (const [act, perms] of Object.entries(acts)) {
          acts[act] = (role.value === ROLES.OWNER) || !!~perms.indexOf(role.value);
        }
      }
      calced.isHakim = isHakim.value;
      return calced;
    }),
  };

  const methods = {
    fetch () {
      const req = fetchProfile();
      const rf = new ReactiveFetch(req, { data: state.data });
      req.then(({ data }) => {
        Object.assign(state, toRefs(rf));
        onSuccessAuth(data);
      });
      return req;
    },

    login (creds) {
      let accs;
      const req = login(creds).then(withResData((data) => {
        if (Array.isArray(data)) {
          accs = data;
          return null;
        }
        else {
          onSuccessAuth(data.user);
          return data;
        }
      }));

      const rf = new ReactiveFetch(req);
      Object.assign(state, toRefs(rf));
      return rf.meta.request.then(withResData(data => accs || data));
    },

    logout () { logout().then(methods.reset) },

    reset () {
      Object.assign(state, new ReactiveFetch());
      bokalSourage.remove(LS_KEY);
      E.emit('Identity:reset');
    },

    requestChangePassword,

    changePassword,
  };

  function onSuccessAuth (user) {
    source.value = 'server';
    bokalSourage.set(LS_KEY, user);
    window.$sentry?.setExtra('identity', user);
  }

  return new Entity({ name, methods, values, state });
})();

export const permsMixin = {
  computed: { PERMS: () => Identity.perms },
};

export { ROLES, PERMS };

export default Identity;
